export enum ChartInterval {
    day = 'day',
    minute = 'minute',
    second = 'second',
    millisecond = 'millisecond'
}
